/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandKotlin = createReactComponent("brand-kotlin", "IconBrandKotlin", [
  ["path", { d: "M20 20h-16v-16h16", key: "svg-0" }],
  ["path", { d: "M4 20l16 -16", key: "svg-1" }],
  ["path", { d: "M4 12l8 -8", key: "svg-2" }],
  ["path", { d: "M12 12l8 8", key: "svg-3" }]
]);

export { IconBrandKotlin as default };
//# sourceMappingURL=IconBrandKotlin.js.map
